import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { LOAD_SAVED_QUERIES } from 'src/store/types';
import Dropdown from 'components/Butterfly/Dropdown/Dropdown.vue';
import DropdownItem from 'components/Butterfly/Dropdown/DropdownItem.vue';
import { BfButton, BfSpinner } from 'components/Butterfly';
import ToggleCheckbox from 'components/widgets/ToggleCheckbox.vue';
import QueryAPI from 'src/api/query';
import { extractText } from 'src/components/DataWidgets/VerbatimsWidget/VerbatimsWidget.utils';
import QueryUtils from "src/utils/query";
import DataUtils from "src/utils/data";
const Radar = Vue.extend({
    components: {
        Dropdown,
        DropdownItem,
        ToggleCheckbox,
        BfButton,
        BfSpinner,
    },
    props: {
        analysisId: { type: Number, required: true },
        projectId: { type: Number, required: true },
    },
    data() {
        return {
            isLoading: true,
            selectedQueries: [],
            results: [],
            canSave: false,
        };
    },
    computed: {
        ...mapGetters([
            'currentAnalysis',
            'currentModel',
            'savedQueries',
            'defaultDateField',
        ]),
        radarQueries() {
            return (this.savedQueries || []).filter((q) => this.selectedQueries.includes(q.id));
        },
        canScan() {
            return this.savedQueries?.length && this.selectedQueries?.length;
        },
    },
    async mounted() {
        this.isLoading = true;
        await this.LOAD_SAVED_QUERIES({ projectId: this.projectId, analysisId: this.analysisId });
        this.selectedQueries = this.savedQueries.filter(({ radar }) => radar).map(({ id }) => id);
        await this.refreshRadar();
        this.isLoading = false;
    },
    methods: {
        ...mapActions({
            LOAD_SAVED_QUERIES,
        }),
        formatDate: DataUtils.formatDate,
        toggleQuerySelect(queryID) {
            this.selectedQueries = this.selectedQueries.includes(queryID)
                ? this.selectedQueries.filter((q) => q !== queryID)
                : this.selectedQueries.concat(queryID);
            this.canSave = true;
        },
        saveSelection() {
            this.isLoading = true;
            this.savedQueries.forEach((query) => {
                const isSelected = this.selectedQueries.includes(query.id);
                const needsUpdate = query.radar !== isSelected;
                if (needsUpdate) {
                    QueryAPI.updateSavedQuery(this.projectId, this.analysisId, {
                        id: query.id,
                        radar: isSelected,
                    });
                }
            });
            this.canSave = false;
            this.isLoading = false;
        },
        async refreshRadar() {
            this.isLoading = true;
            const results = await QueryAPI.scanRadar(this.projectId, this.analysisId);
            this.results = results;
            this.isLoading = false;
        },
        async clearRadar() {
            this.isLoading = true;
            await QueryAPI.clearRadar(this.projectId, this.analysisId);
            await this.refreshRadar();
            this.isLoading = false;
        },
        textValues(query) {
            let nodes = QueryUtils.getQueryLeafNodesFromBotanicQuery(query.query_value);
            return nodes.filter((n) => n.type === 'text').map((n) => n.value);
        },
        extractText(query, value, topics) {
            return extractText(value, topics, this.currentModel.topics, this.currentModel.terms, this.currentModel.conceptColours, this.textValues(query));
        },
        getQuery(id) {
            return this.savedQueries.find((q) => q.id === id);
        },
    }
});
export default Radar;
